import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import useErrorInfoModal from '@features/modal/hooks/useErrorInfoModal'

import Button from '@shared/ui/button'

import styles from './styles.module.scss'



export default function InfoModal () {
  const isTablet = useMediaQuery('(max-width: 767px)')
  const { t: tc } = useTranslation('common')
  const { closeErrorInfoModal } = useErrorInfoModal()

  return (
    <Button
      size={isTablet ? 'large' : 'medium'}
      className={styles['bottom-button-close']}
      onClick={closeErrorInfoModal}
    >
      {tc('close')}
    </Button>
  )
}
